


































































































































































































































































































































































































































































































































































import Confirmacao from '@/components/ui/Confirmacao.vue';
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue';
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { FormaDePagamento, Loja, Promocao, TipoDeCliente, RegraDeAplicacaoPromocao, PromocaoDescontoProgressivo } from '@/models';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds';
import { TipoDeOperacao } from '@/models/Recurso'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeCategoria from '@/views/application/produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue';
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue';
import DatePicker from '../ui/DatePicker.vue'
import SeletorDeMarca from '../produto/SeletorDeMarca.vue';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import SeletorDeTipoDeCliente from '../tabeladepreco/SeletorDeTipoDeCliente.vue';
import DialogoDeBuscaDeLoja from '../loja/DialogoDeBuscaDeLoja.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { SavePromocaoUseCase } from '@/usecases';
import { dateToPtBrFormat } from '@/shareds/date/date-utils';
import DialogoDeUploadDeArquivoParaBuscaDeProdutos from '@/views/application/dialogosGenericos/DialogoDeUploadDeArquivoParaBuscaDeProdutos.vue';


@Component({
	components: {
		DataTableDeCrud,
		Confirmacao,
		SeletorDeTag,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeGenero,
		DatePicker,
		SeletorDeMarca,
		SeletorDeTipoDeCliente,
		DialogoDeBuscaDeLoja,
		DialogoDeUploadDeArquivoParaBuscaDeProdutos,
	},
})
export default class DialogoDeEdicaoDePromocao extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeUploadDeArquivoParaBuscaDeProdutos!: DialogoDeUploadDeArquivoParaBuscaDeProdutos

	mostra = false
	salvando = false
	promocao: Promocao | null = null
	criandoPromocao = false
	tipoDeClienteSelecionado: TipoDeCliente | null = null
	mostrarAdicaoDeTipoDeCliente = false
	obrigatorio = obrigatorio
	savePromocaoUseCase = new SavePromocaoUseCase()
	dateToPtBrFormat = dateToPtBrFormat

	etapa = 1

	limparValor(regra: RegraDeAplicacaoPromocao) {
		regra.valor = '';
	}

	gatilhoSelecionado = 'Valor total do carrinho'

	headersTipoDeCliente = [
		{ text: 'Tipo', value: 'nome' },
	]

	regras: RegraDeAplicacaoPromocao[] = [
		{
			id: '',
			promocao: '',
			tipoDeGatilho: 'Valor total do carrinho',
			operadorCondicao: '≥',
			valor: '200',
			ordem: 0,
			condicaoLogica: '',
		},
	]

	tiposDeGatilhos = [
		'Valor total do carrinho',
		'Quantidade de itens',
		'Presença de SKU específico',
		'Método de pagamento',
	]

	opcoesDeCampos = [
		'Valor total do carrinho',
		'Quantidade de itens',
		'Presença de SKU específico',
		'Método de pagamento',
	]

	opcoesDeOperadores = ['é', '≥', '≤']

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Cartão',
		'Dinheiro',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Boleto',
		'Pix',
		'Outros',
	]

	tipoBeneficioSelecionado = 'Desconto';
	tipoDescontoSelecionado = 'Progressivo';

	headersLojas = [
		{ text: 'Nome', value: 'nomeFantasia' },
		{ text: 'CNPJ', value: 'cnpj' },
	]

	adicionarRegra() {
		this.regras.push({
			id: '',
			promocao: '',
			tipoDeGatilho: '',
			operadorCondicao: '',
			valor: '',
			ordem: this.regras.length,
			condicaoLogica: '',
		})
	}

	removerRegra(index: number) {
		this.regras.splice(index, 1)
	}

	mostrar(promocao: Promocao | null, criarPromocao: boolean) {
		if (!promocao) return
		this.promocao = promocao
		this.mostra = true
		this.criandoPromocao = criarPromocao
		
		if (criarPromocao || promocao.id === '') {
			this.resetarParaValoresPadrao()
		} else {
			this.carregarDadosSalvos()
		}
	}

	private resetarParaValoresPadrao() {
		const ehSorteio = this.promocao?.tipoDePromocao === 'Sorteio'
		this.tipoBeneficioSelecionado = ehSorteio ? 'Sorteio' : 'Desconto'
  
		this.regras = [
			{
				id: '',
				promocao: '',
				tipoDeGatilho: 'Valor total do carrinho',
				operadorCondicao: '≥',
				valor: '200',
				ordem: 0,
				condicaoLogica: '',
			},
		]
  
		this.niveisDesconto = ehSorteio
			? []
			: [
				{ id: '', promocao: '', quantidadeDePecas: 2, percentualDeDesconto: 10 },
				{ id: '', promocao: '', quantidadeDePecas: 3, percentualDeDesconto: 15 },
			]

		this.niveisSorteio = ehSorteio
			? [
				{ id: '', promocao: '', valorMinimoDeCompra: 200, quantidadeDeSorteios: 1 },
			]
			: []
	}

	private carregarDadosSalvos() {
		if (!this.promocao) return
		
		if (this.promocao.regrasDeAplicacaoPromocao && this.promocao.regrasDeAplicacaoPromocao.length > 0) {
			this.regras = [...this.promocao.regrasDeAplicacaoPromocao]
		}
		
		const ehSorteio = this.promocao.tipoDePromocao === 'Sorteio'

		this.tipoBeneficioSelecionado = ehSorteio ? 'Sorteio' : 'Desconto'

		if (ehSorteio) {
			this.niveisDesconto = []

			this.niveisSorteio =
			this.promocao.sorteios && this.promocao.sorteios.length > 0
				? [...this.promocao.sorteios]
				: [
					{
						id: '',
						promocao: '',
						valorMinimoDeCompra: 200,
						quantidadeDeSorteios: 1,
					},
				]
		} else {
			this.niveisSorteio = []

			this.niveisDesconto =
			this.promocao.promocoesDescontoProgressivo &&
			this.promocao.promocoesDescontoProgressivo.length > 0
				? [...this.promocao.promocoesDescontoProgressivo]
				: [
					{
						id: '',
						promocao: '',
						quantidadeDePecas: 2,
						percentualDeDesconto: 10,
					},
				]
		}

		this.tipoBeneficioSelecionado = this.promocao.tipoDePromocao === 'Sorteio' ? 'Sorteio' : 'Desconto'
	}

	esconder() {
		this.etapa = 1
		this.promocao = null
		this.mostra = false
		
		this.resetarParaValoresPadrao()
	}

	async salvar(promocao: Promocao | null, ativar: boolean) {
		if (!promocao) return

		if (!this.validarCamposObrigatorios(promocao)) {
			return
		}

		if (!this.validarNiveisDesconto()) {
			AlertModule.setError("Valide os níveis de desconto progressivo configurados, há quantidades repetidas.")
			return
		}

		if (!this.validarNiveisSorteio()) {
			return
		}

		if (!this.validarConsistenciaDoSorteio()) {
			return
		}
		
		try {
			this.salvando = true

			const promocaoParaEnviar = {
				...promocao,
				ativa: ativar === false ? false : promocao.ativa,
				beneficio: this.tipoBeneficioSelecionado === 'Desconto' ? this.tipoDescontoSelecionado : this.tipoBeneficioSelecionado,
				regrasDeAplicacaoPromocao: [...this.regras].sort((a, b) => a.ordem - b.ordem).map((regra, index) => ({
					tipoDeGatilho: regra.tipoDeGatilho,
					operadorCondicao: regra.operadorCondicao,
					valor: regra.valor,
					ordem: regra.ordem,
					condicaoLogica: index === 0 ? 'SE' : regra.condicaoLogica,
				})),
				promocoesDescontoProgressivo: this.niveisDesconto.map(nivel => ({
					quantidadeDePecas: nivel.quantidadeDePecas,
					percentualDeDesconto: nivel.percentualDeDesconto,
				})),
				sorteios: this.niveisSorteio.map(nivel => ({
					valorMinimoDeCompra: nivel.valorMinimoDeCompra,
					quantidadeDeSorteios: nivel.quantidadeDeSorteios,
				})),
			}

			if (promocao.id === '') {
				const promocaoSalva = await this.savePromocaoUseCase.criarPromocao(promocaoParaEnviar as Promocao)

				this.$emit('incluirPromocaoNova', promocaoSalva)
				AlertModule.setSuccess('Promoção criada com sucesso!')
			} else {
				const promocaoSalva = await this.savePromocaoUseCase.atualizarPromocao(promocaoParaEnviar as Promocao)

				this.$emit('atualizarPromocaoExistente', promocaoSalva)
				AlertModule.setSuccess('Promoção atualizada com sucesso!')
			}
			
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	validarCamposObrigatorios(promocao: Promocao): boolean {
		if (!promocao.nome) {
			AlertModule.setError("O nome da promoção é obrigatório")
			return false
		}

		if (!promocao.tipoDePromocao) {
			AlertModule.setError("O tipo de promoção é obrigatório")
			return false
		}

		if (!promocao.dataInicio) {
			AlertModule.setError("A data de início é obrigatória")
			return false
		}

		if (!promocao.dataFim) {
			AlertModule.setError("A data de fim é obrigatória")
			return false
		}

		if (promocao.dataFim < promocao.dataInicio) {
			AlertModule.setError("A data de fim não pode ser anterior à data de início")
			return false
		}

		if (!promocao.lojas || promocao.lojas.length === 0) {
			AlertModule.setError("É necessário vincular pelo menos uma loja")
			return false
		}

		if (this.tipoBeneficioSelecionado === 'Desconto') {
			if (!this.niveisDesconto || this.niveisDesconto.length === 0) {
				AlertModule.setError("É necessário configurar pelo menos um nível de desconto")
				return false
			}

			for (const nivel of this.niveisDesconto) {
				if (!nivel.quantidadeDePecas || nivel.quantidadeDePecas < 1) {
					AlertModule.setError("A quantidade de peças deve ser maior que zero")
					return false
				}
				if (!nivel.percentualDeDesconto || nivel.percentualDeDesconto <= 0 || nivel.percentualDeDesconto > 100) {
					AlertModule.setError("O percentual de desconto deve estar entre 1 e 100")
					return false
				}
			}
		}

		if (this.tipoBeneficioSelecionado === 'Sorteio') {
			if (!this.niveisSorteio || this.niveisSorteio.length === 0) {
				AlertModule.setError("É necessário configurar pelo menos um nível de sorteio")
				return false
			}

			for (const nivel of this.niveisSorteio) {
				if (!nivel.valorMinimoDeCompra || nivel.valorMinimoDeCompra <= 0) {
					AlertModule.setError("O valor mínimo da compra deve ser maior que zero")
					return false
				}
				if (!nivel.quantidadeDeSorteios || nivel.quantidadeDeSorteios <= 0) {
					AlertModule.setError("A quantidade de sorteios deve ser maior que zero")
					return false
				}
			}
		}

		if (!this.regras || this.regras.length === 0) {
			AlertModule.setError("É necessário configurar pelo menos uma regra de aplicação")
			return false
		}

		for (const regra of this.regras) {
			if (!regra.tipoDeGatilho) {
				AlertModule.setError("O tipo de gatilho é obrigatório para todas as regras")
				return false
			}
			if (!regra.operadorCondicao) {
				AlertModule.setError("O operador de condição é obrigatório para todas as regras")
				return false
			}
			if (!regra.valor) {
				AlertModule.setError("O valor é obrigatório para todas as regras")
				return false
			}
		}

		return true
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'promocoes'))
	}

	get podeAlterarPromocao() {
		return this.podeRealizarOperacao('alterar')
	}

	get tiposDeCliente(): TipoDeCliente[] {
		if (!this.promocao) return []

		return this.promocao.tiposDeCliente
	}

	removerTipoDeCliente(indice) {
		if (!this.promocao) return

		if (this.promocao.tiposDeCliente.length > -1) {
			this.promocao.tiposDeCliente.splice(indice, 1)
		}
	}

	adicionarTipoDeCliente() {
		if (!this.promocao) return
		if (!this.tipoDeClienteSelecionado) return

		try {
			if (this.promocao.tiposDeCliente.filter(tipo => tipo.id === this.tipoDeClienteSelecionado?.id).length > 0) {
				throw new Error('Tipo de cliente já foi adicionado')
			}

			this.promocao.tiposDeCliente.push(this.tipoDeClienteSelecionado)


		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.fecharDialogoDeAdicaoDeTipoDeCliente()
		}
	}

	fecharDialogoDeAdicaoDeTipoDeCliente() {
		this.mostrarAdicaoDeTipoDeCliente = false
		this.tipoDeClienteSelecionado = null
	}

	valorPositivo = (val: number) => {
		return val >= 0.01;
	}


	niveisDesconto: PromocaoDescontoProgressivo[] = [
		{ 
			id: '',
			promocao: '',
			quantidadeDePecas: 2, 
			percentualDeDesconto: 10,
		}, 
		{ 
			id: '',
			promocao: '',
			quantidadeDePecas: 3, 
			percentualDeDesconto: 15, 
		},
	];

	niveisSorteio = [
		{
			id: '',
			promocao: '',
			valorMinimoDeCompra: 200,
			quantidadeDeSorteios: 1,
		},
	]

	handleUmaVezPorDiaChange() {
		if (this.promocao?.aplicavelUmaVezPorDia) {
			this.promocao.aplicavelUmaVezPorMes = false;
		}
	}

	handleUmaVezPorMesChange() {
		if (this.promocao?.aplicavelUmaVezPorMes) {
			this.promocao.aplicavelUmaVezPorDia = false;
		}
	}

	adicionarLoja(loja: Loja) {
		if (!this.promocao) return
		if (!loja) return

		try {

			if (this.promocao.lojas.find(lojaDaPromocao => lojaDaPromocao.id === loja.id)) {
				throw new Error('Loja já foi adicionada')
			}

			this.promocao.lojas.push(loja)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	removerLoja(indice) {
		this.promocao?.lojas.splice(indice, 1)
	}

	validarNiveisDesconto(): boolean {
		const quantidades = this.niveisDesconto.map(nivel => nivel.quantidadeDePecas);
		const hasDuplicados = new Set(quantidades).size !== quantidades.length;

		if (hasDuplicados) {
			AlertModule.setError("Não é permitido cadastrar mais de um nível com a mesma quantidade mínima de peças.");
			return false;
		}

		return true;
	}

	abrirDialogoDeBuscaDeProdutosPorCsv(){
		this.dialogoDeUploadDeArquivoParaBuscaDeProdutos.mostrar()
	}

	preencherProdutosBuscados(produtos) {
		this.promocao?.skus.push(...produtos);
	}

	@Watch('promocao.tipoDePromocao')
	onTipoDePromocaoChange(val: string) {
		if (val === 'Sorteio') {
			this.tipoBeneficioSelecionado = 'Sorteio'
			this.niveisDesconto = []
		
			if (!this.niveisSorteio.length) {
				this.niveisSorteio = [
					{
						id: '',
						promocao: '',
						valorMinimoDeCompra: 100,
						quantidadeDeSorteios: 1,
					},
				]
			}
		} else {
			this.tipoBeneficioSelecionado = 'Desconto'
			this.niveisSorteio = []
		
			if (!this.niveisDesconto.length) {
				this.niveisDesconto = [
					{
						id: '',
						promocao: '',
						quantidadeDePecas: 2,
						percentualDeDesconto: 10,
					},
				]
			}
		}
	}

	adicionarNivelDesconto() {
		this.niveisDesconto.push({
			id: '',
			promocao: '',
			quantidadeDePecas: 1,
			percentualDeDesconto: 0,
		})
	}

	removerNivelDesconto(i: number) {
		this.niveisDesconto.splice(i, 1)
	}

	adicionarNivelSorteio() {
		this.niveisSorteio.push({
			id: '',
			promocao: '',
			valorMinimoDeCompra: 0,
			quantidadeDeSorteios: 1,
		})
	}

	removerNivelSorteio(i: number) {
		this.niveisSorteio.splice(i, 1)
	}

	validarNiveisSorteio(): boolean {
		if (this.tipoBeneficioSelecionado !== 'Sorteio') {
			return true
		}

		const valoresMinimos = this.niveisSorteio.map(nivel => Number(nivel.valorMinimoDeCompra))
		const quantidadesDeSorteios = this.niveisSorteio.map(nivel => Number(nivel.quantidadeDeSorteios))

		const hasValoresDuplicados = new Set(valoresMinimos).size !== valoresMinimos.length
		if (hasValoresDuplicados) {
			AlertModule.setError("Não é permitido cadastrar mais de um nível com o mesmo valor mínimo para sorteio.")
			return false
		}

		const hasQuantidadesDuplicadas = new Set(quantidadesDeSorteios).size !== quantidadesDeSorteios.length
		if (hasQuantidadesDuplicadas) {
			AlertModule.setError("Não é permitido cadastrar a mesma quantidade de números sorteados para valores mínimos diferentes.")
			return false
		}

		const niveisOrdenados = [...this.niveisSorteio].sort(
			(a, b) => Number(a.valorMinimoDeCompra) - Number(b.valorMinimoDeCompra),
		)

		for (let i = 1; i < niveisOrdenados.length; i++) {
			const nivelAnterior = niveisOrdenados[i - 1]
			const nivelAtual = niveisOrdenados[i]

			if (Number(nivelAtual.quantidadeDeSorteios) <= Number(nivelAnterior.quantidadeDeSorteios)) {
				AlertModule.setError(
					"Ao aumentar o valor mínimo da compra, a quantidade de números sorteados também deve aumentar.",
				)
				return false
			}
		}

		return true
	}

	private validarConsistenciaDoSorteio(): boolean {
		if (this.tipoBeneficioSelecionado !== 'Sorteio') {
			return true
		}

		const regraValorMinimo = this.regras.find(regra => regra.tipoDeGatilho === 'Valor total do carrinho')

		if (!regraValorMinimo) {
			AlertModule.setError('Para promoções de sorteio, é necessário configurar uma regra de "Valor total do carrinho".')
			return false
		}

		if (regraValorMinimo.operadorCondicao !== '≥') {
			AlertModule.setError('Para promoções de sorteio, a regra de "Valor total do carrinho" deve usar o operador "≥".')
			return false
		}

		const nivelUmSorteio = this.niveisSorteio.find(nivel => Number(nivel.quantidadeDeSorteios) === 1)

		if (!nivelUmSorteio) {
			AlertModule.setError('É necessário configurar um nível de sorteio com 1 número sorteado.')
			return false
		}

		const valorDaRegra = Number(regraValorMinimo.valor)
		const valorMinimoDoNivelInicial = Number(nivelUmSorteio.valorMinimoDeCompra)

		if (valorDaRegra !== valorMinimoDoNivelInicial) {
			AlertModule.setError(`O valor mínimo da regra de sorteio (${valorDaRegra}) deve ser igual ao valor mínimo do nível com 1 sorteio (${valorMinimoDoNivelInicial}).`)
			return false
		}

		return true
	}

}
